import { Col, Icon, Text, useTheme } from "@rally/ui-kit";
import { useEffect, useState } from "react";
import { say } from "../../localization/say.ts";
import { type Frame, frameOf } from "./working.ts";

const A_SECOND = 1000;

export function useNow(running: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!running) return;
    setNow(Date.now());
    const beat = setInterval(() => setNow(Date.now()), A_SECOND);
    return () => clearInterval(beat);
  }, [running]);
  return now;
}

export const A_LINE_HOLDS = 3;

export function ToolFrame({ frame, most = A_LINE_HOLDS }: { frame: Frame | null; most?: number }) {
  const theme = useTheme();
  const drawn = frameOf(frame, most);
  if (!drawn) return null;
  return (
    <Col
      testID="tool-frame"
      style={{ flexDirection: "row", alignItems: "center", gap: theme.space[2], flexShrink: 1 }}
    >
      {drawn.did.map((step, at) => (
        <Col
          key={`${at}:${step.tool}`}
          style={{ flexDirection: "row", alignItems: "center", gap: 2, flexShrink: 1 }}
        >
          <Icon name={step.ok ? "check" : "close"} size={11} color={step.ok ? "text.tertiary" : "danger"} />
          <Text typeName="caption" color="text.tertiary" numberOfLines={1}>
            {step.tool}
          </Text>
        </Col>
      ))}
      {drawn.more > 0 ? (
        <Text typeName="caption" color="text.tertiary" testID="tool-frame-more">
          {say("agent.andMore")(drawn.more)}
        </Text>
      ) : null}
    </Col>
  );
}
